var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 8,
    viewBox: "0 0 19 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.13256 5.40625H15.3169L11.9349 1.11719C11.8388 0.995313 11.9255 0.8125 12.0826 0.8125H13.6013C13.831 0.8125 14.049 0.917969 14.1896 1.09844L18.0333 5.97344C18.4201 6.46563 18.0708 7.1875 17.4451 7.1875H1.13256C1.02943 7.1875 0.945055 7.10313 0.945055 7V5.59375C0.945055 5.49062 1.02943 5.40625 1.13256 5.40625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfArrow);
export default __webpack_public_path__ + "static/media/half-arrow.54d006910191ee8f971904aec4a9b498.svg";
export { ForwardRef as ReactComponent };